export * from './src/restaurants-catalogs-v3-catalog-catalogs.meta.js';
